import React, { useEffect, useState } from 'react';
import styled from 'styled-components';

import InfoBtn from '@components/dataEntry/button/InfoBtn';
import { BATTLE_TYPE, BATTLE_TYPE_VALUE, BATTLE_MODE_VALUE, BATTLE_MODE } from '@typings/common/battleType';
import SearchUserInput from '@components/dataEntry/Input/TagInput/SearchUserInput';
import { IUser } from '@typings/setting/userType.interface';
import RockSissorsPaper from './RockSissorsPaper';

export const AttatchmentWrapper = styled.div`
  margin-bottom: 8px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px;
  width: 100%;

  strong {
    font-size: 12px;
    color: var(--subTextColor);
    display: inline-block;
  }

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
  }
`;

type Props = {
  collectionPath: string;
  setBattleResult: any;
  setBattleOpponentId: any;
  battleMode?: BATTLE_MODE_VALUE;
};
function BattleMode({
  collectionPath,
  setBattleResult,
  setBattleOpponentId,
  battleMode = BATTLE_MODE.INSTANT,
}: Props) {
  const [selectedUser, setSelectedUser] = useState<IUser[]>([]);
  const [battleType, setBattleType] = useState<BATTLE_TYPE_VALUE>(
    BATTLE_TYPE.RSP,
  );

  useEffect(() => {
    if (selectedUser.length > 0) {
      setBattleOpponentId(selectedUser[0].id);
    } else {
      setBattleOpponentId('');
    }
  }, [selectedUser]);

  const isChallenge = battleMode === BATTLE_MODE.CHALLENGE;

  const tooltipText = isChallenge
    ? '내 패를 숨긴 채 상대에게 도전장을 보냅니다.<br>상대가 패를 선택하면 결과가 공개됩니다.'
    : '댓글 입력시 상대방은 랜덤 선택을 하고, <br>즉시 배틀 결과가 출력됩니다.';

  const battleTypeMap = {
    [BATTLE_TYPE.RSP]: (
      <>
        <RockSissorsPaper setBattleResult={setBattleResult} />
      </>
    ),
  };

  return (
    <AttatchmentWrapper>
      <strong>{isChallenge ? '도전장 대상' : '배틀 대상'}</strong>
      <div style={{ display: 'flex', gap: 4, alignItems: 'center' }}>
        <div style={{ position: 'relative', zIndex: 100 }}>
          <SearchUserInput
            userList={selectedUser}
            setUserList={setSelectedUser}
            onlySelect
            placeholder="멤버 검색"
            dropdownStyle={{ maxHeight: 140 }}
          />
        </div>
        <InfoBtn tooltip={tooltipText} />
      </div>
      {battleTypeMap[battleType]}
    </AttatchmentWrapper>
  );
}

export default BattleMode;
